import './head.scss'
import { useLocation, useNavigate }from "react-router-dom"; 
import LoggedHead from '../loggedHead/loggedHead';

const Head = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    return (
        <div
            className={`Head LoginHead`}
            style={{
                backgroundColor: location.pathname == '/' ? 'transparent' : '#FFFFFF',
                borderBottom: location.pathname == '/' ? 'none' : '1px solid #F3F3F3'
            }}
        >
            <div className={`head_left`}>
                <div className='logo'></div>
            </div>
            {location.pathname == '/' ? null :
            <div className='head_right'>
                <LoggedHead />
            </div>}
        </div>
    );
};

export default Head;